import React from 'react';
import { useQuery } from 'react-query';
import { useParams } from 'react-router-dom';
import { Box, Center, Flex, Spinner, Image, Text, VStack, } from '@chakra-ui/react';
import Masthead from '../components/Masthead';
import { Checker as CheckerComponent } from '../components';
import { CheckerService } from '../services';
// Images
import notFoundErrorImage from '../assets/states/error-404.svg';
import Logo from '../assets/checkfirst-logo.svg';
export var Checker = function () {
    var id = useParams().id;
    var _a = useQuery(['checker', id], function () { return CheckerService.getPublishedChecker(id); }), isLoading = _a.isLoading, isError = _a.isError, config = _a.data;
    function isEmbedded() {
        try {
            return window.self !== window.top;
        }
        catch (_) {
            return true;
        }
    }
    return (React.createElement(React.Fragment, null,
        !isEmbedded() && React.createElement(Masthead, null),
        React.createElement(Flex, { direction: "column", bg: { base: 'white', lg: 'neutral.200' }, alignItems: "center", minH: "100vh", py: { base: '0px', lg: '64px' } },
            !isLoading && !isError && config && config.isActive && (React.createElement(CheckerComponent, { config: config })),
            isLoading && (React.createElement(Center, { py: 16 },
                React.createElement(Spinner, { size: "xl", color: "primary.500", thickness: "4px" }))),
            !isLoading && (isError || !(config === null || config === void 0 ? void 0 : config.isActive)) && (React.createElement(Center, { py: 16 },
                React.createElement(VStack, { spacing: 4 },
                    React.createElement(Image, { flex: 1, src: notFoundErrorImage, height: { base: '257px', lg: 'auto' }, mb: { base: '24px', lg: '0px' } }),
                    React.createElement(Text, { textStyle: "heading2", color: "primary.500" }, "There\u2019s nothing here."),
                    React.createElement(Text, { textStyle: "body1" }, "If you think this is a mistake, please contact the agency that gave you the checker link."),
                    React.createElement(Box, { pt: 32 },
                        React.createElement(Image, { htmlWidth: "144px", src: Logo }))))))));
};
export default Checker;
